declare global {
  interface Window {
    sentry?: {
      error: (info: { topic: string; team: string; error: string; sampleRate?: number }) => void;
      warn: (info: { topic: string; team: string; error: string; sampleRate?: number }) => void;
    };
  }
}

function resetApp() {
  localStorage.clear();
  sessionStorage.clear();
  window.sentry?.error({
    topic: 'nwx-infra',
    team: 'users-infra',
    error: 'Reset app',
    sampleRate: 1,
  });
  window.location.reload();
}

function showResetAfterLoadTimeout() {
  const reset = document.querySelector<HTMLElement>('#reset');
  const resetContainer = document.querySelector<HTMLElement>('.app-loader');

  if (reset) {
    reset.style.visibility = 'visible';
  }

  // If the app successfully loaded, the app-loader div would have been removed from the DOM.
  if (resetContainer) {
    resetContainer.style.zIndex = '100';
    window.sentry?.warn({
      topic: 'nwx-infra',
      team: 'users-infra',
      error: 'App load timeout',
      sampleRate: 1,
    });
  }
}

export function initResetLoader() {
  const resetButton = document.querySelector<HTMLElement>('#reset-button');

  if (resetButton) {
    resetButton.addEventListener('click', resetApp);
  }

  setTimeout(showResetAfterLoadTimeout, 40000);
}
